import { createContext, useContext, useState, useEffect } from 'react';

const FoodContext = createContext();

export function useFood() {
  return useContext(FoodContext);
}

export function FoodProvider({ children }) {
  // The Plate: Array of { id (unique instance id), foodItem, quantity, unit, calculatedCarbs }
  const [plate, setPlate] = useState([]);

  // Load from local storage on mount
  useEffect(() => {
    const saved = localStorage.getItem('glucoscout_plate');
    if (saved) {
      try {
        setPlate(JSON.parse(saved));
      } catch (e) {
        console.error('Failed to parse saved plate', e);
      }
    }
  }, []);

  // Save to local storage on change
  useEffect(() => {
    localStorage.setItem('glucoscout_plate', JSON.stringify(plate));
  }, [plate]);

  const addToPlate = (item) => {
    // Item should have: foodItem (obj), quantity (number), unit (string), calculatedCarbs (number)
    const instanceId = Date.now().toString() + Math.random().toString(36).substr(2, 9);
    setPlate(prev => [...prev, { ...item, id: instanceId }]);
  };

  const removeFromPlate = (instanceId) => {
    setPlate(prev => prev.filter(item => item.id !== instanceId));
  };

  const clearPlate = () => {
    setPlate([]);
  };

  const totalCarbs = plate.reduce((sum, item) => sum + (item.calculatedCarbs || 0), 0);

  return (
    <FoodContext.Provider value={{ 
      plate, 
      addToPlate, 
      removeFromPlate, 
      clearPlate,
      totalCarbs 
    }}>
      {children}
    </FoodContext.Provider>
  );
}
